import { FormatRegistry } from '@sinclair/typebox';

FormatRegistry.Set('uuid', (value) => /[a-f\d-]{32,36}/i.test(value));
